import anime from 'animejs/lib/anime.es.js';
import { CountUp } from 'countup.js';
import { debounce } from 'debounce';

export default class PackageToggle {
  // html selector for the component
  static selectorString() {
    return '.js-package';
  }

  // rootNode = html element with js-class
  // props = data attribute 'props' to pass down customization
  constructor(rootNode) {
    this.$refs = {
      rootNode,
      toggler: rootNode.querySelector('.js-package-button'),
      package: document.getElementById(rootNode.dataset.packageId),
      packageForm: document.getElementById(rootNode.dataset.packageId).querySelector('.package-form-wrap'),
      arrow: rootNode.querySelector('.arrow'),
      floatTag: {
        elem: document.getElementById(`${rootNode.dataset.packageId}-float-price`),
        enabled: false,
      },
    };

    this.countUp = new CountUp(this.$refs.floatTag.elem.querySelector('.package-form-price-value'), 2000, {
      startVal: 0,
      separator: '.',
      suffix: ',-',
    });

    this.isOpen = false;
    this.debouncedScrollListener = debounce(this.scrollUpdater.bind(this), 250);

    this.clickHandler();
    this.priceUpdater();
  }

  animationArrow() {
    anime({
      targets: this.$refs.arrow.querySelector('path'),
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: 'easeInOutSine',
      duration: 1000,
    });
  }

  animationArrowHide() {
    anime({
      targets: this.$refs.arrow.querySelector('path'),
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: 'easeInOutSine',
      duration: 1000,
      delay: 500,
      direction: 'reverse',
    });
  }

  animationShow() {
    this.$refs.rootNode.classList.add('is-open');
    this.$refs.toggler.classList.add('is-out');
    window.dispatchEvent(new Event('show-package'));

    if (this.$refs.arrow) this.animationArrow();

    if (this.$refs.floatTag.elem) {
      this.$refs.floatTag.enabled = true;
      window.addEventListener('scroll', this.debouncedScrollListener);
    }

    anime({
      targets: this.$refs.package,
      height: this.getFormularHeight(),
      opacity: [0, 1],
      duration: 800,
      delay: this.$refs.arrow ? 200 : 0,
      easing: 'cubicBezier(0, 0, .2, 1)',
      complete: function(anim) {
        anim.animatables[0].target.style.pointerEvents = 'all';
      },
    });
  }

  animationClose() {
    this.$refs.rootNode.classList.remove('is-open');
    this.$refs.toggler.classList.remove('is-out');
    window.dispatchEvent(new Event('hide-package'));

    if (this.$refs.arrow) this.animationArrowHide();
    if (window.matchMedia('(max-width: 768px)').matches) this.$refs.rootNode.scrollIntoView();

    if (this.$refs.floatTag) {
      this.$refs.floatTag.elem.classList.remove('is-visible');
      this.$refs.floatTag.enabled = false;
      window.removeEventListener('scroll', this.debouncedScrollListener);
    }

    anime({
      targets: this.$refs.package,
      height: 0,
      opacity: [1, 0],
      duration: 500,
      easing: 'cubicBezier(0.4, 0, 1, 1)',
      delay: 350,
      complete: (anim) => {
        anim.animatables[0].target.style.pointerEvents = 'none';
      },
    });
  }

  priceUpdater() {
    window.addEventListener(`price-update-${this.$refs.rootNode.dataset.packageId}`, e => {
      this.countUp.update(e.detail.price);
    }, false);
  }

  scrollUpdater() {
    const form = this.$refs.packageForm.getBoundingClientRect();

    const formHeight = form.height;
    const scrollBottom = formHeight - form.bottom;

    const min = formHeight * 0.01;
    const max = formHeight * 0.5;

    if (this.$refs.floatTag.enabled && form.bottom > 0 && scrollBottom > min && scrollBottom < max) {
      this.$refs.floatTag.elem.classList.add('is-visible');
    } else {
      this.$refs.floatTag.elem.classList.remove('is-visible');
    }
  }

  getFormularHeight() {
    const formWrap = this.$refs.package.querySelector('.package-form-wrap');
    const formBtnWrap = this.$refs.package.querySelector('.package-form-button-wrap');
    const formWrapMargin = getComputedStyle(formWrap);

    return formWrap.getBoundingClientRect().height + formBtnWrap.getBoundingClientRect().height + parseFloat(formWrapMargin.marginTop) + parseFloat(formWrapMargin.marginBottom);
  }

  clickHandler() {
    this.$refs.toggler.addEventListener('click', e => {
      if (this.isOpen) this.animationClose();
      else this.animationShow();

      this.isOpen = !this.isOpen;
    });

    const closeBtns = [...this.$refs.package.querySelectorAll('.js-package-close')];

    if (closeBtns.length) {
      closeBtns.forEach(btn => btn.addEventListener('click', e => {
        this.$refs.toggler.click();
      }));
    }
  }
}
